import styles from './AmazonECS.module.scss'
import { Problem } from '../pages/ECS/Problem'
import { Top } from '../pages/ECS/Top'
import { Solution } from '../pages/ECS/Solution'
import { Merit } from '../pages/ECS/Merit'
import { Partner } from '../pages/ECS/Partner'
import { Suggestion } from '../pages/ECS/Suggestion'
import { Architecture } from '../pages/ECS/Architecture'
import { Price } from '../pages/ECS/Price'
import { CaseStudy } from '../pages/ECS/CaseStudy'
import { Flow } from '../pages/ECS/Flow'
import { FAQ } from '../pages/ECS/FAQ'
import { Introduce } from '../pages/ECS/Introduce'
import { Contact } from '../pages/ECS/Contact'

const ContactFormId = 'd906c027-526f-4ae2-8ccc-282a7aecf470'

const paths = [
  { name: 'TOP', url: '/' },
  { name: 'Services', url: '/services' },
  { name: 'クラウドネイティブ', url: '/services/forge/cloudnative/' },
  { name: 'Amazon ECS', url: '#' },
]

const TopContents = {
  smallTitle: 'コンテナ技術を活用したアプリケーション運用の簡素化',
  title: 'Amazon ECS',
  text: 'コンテナ環境の構築・運用に悩む企業に、高可用性とスケーラビリティを兼ね備えたコンテナソリューションを提供します。',
  imgLink: '/img/common/aws_amazon_ecs_delivery_partner.svg',
}

const ProblemContents = {
  title: 'こんな課題はありませんか？',
  subTitle: 'サービスの安定性と開発のスピードアップに関してのお悩みを解決します。',
  list: [
    {
      text: 'アクセス増加時の対応を考慮できていない',
      icon: '/images/LP/LP202407/AmazonECS/Icon/BsGraphUp.svg',
    },
    {
      text: '開発環境と本番環境の差異が大きくリリースが不安',
      icon: '/images/LP/LP202407/AmazonECS/Icon/BsExclude.svg',
    },
    {
      text: 'プログラム更新の作業負担が大きい',
      icon: '/images/LP/LP202407/AmazonECS/Icon/BsShareFill.svg',
    },
  ],
}

const SolutionContents = {
  firstLine: [
    {
      text: 'Amazon ECS',
      color: '#bf012d',
    },
    {
      text: 'なら',
      color: '#1f1f1f',
    },
  ],
  secondLine: [
    {
      text: 'デプロイの手間やトラブルを大幅に削減',
      color: '#bf012d',
    },
    {
      text: 'できます',
      color: '#1f1f1f',
    },
  ],
  description: [
    'Amazon Elastic Container Service (以下、Amazon ECS) は、AWSが提供するフルマネージド型のコンテナオーケストレーションサービスです。Amazon ECSは、アプリケーションのデプロイ、管理、スケーリングをシンプルに行えるよう設計されています。基本的にアプリケーションは、複数のコンテナで構成されています。',
    'Amazon ECSは、複数あるコンテナを上手くコントロールし、AWS上で効率的に実行・管理するためのツールです。',
    'Amazon ECS導入支援サービスは、お客さまのビジネスニーズに合わせたECS環境の設計、構築、運用をサポートします。',
    '豊富な経験と専門知識を活かし、スムーズなコンテナ環境への移行と効率的な運用を実現します。',
  ],
  list: [
    {
      text: '運用コスト削減やスケーラビリティの向上',
      icon: '/images/LP/LP202407/AmazonECS/Icon/GitPullRequestClosed.svg',
    },
    {
      text: '開発環境と本番環境の差異を最小限',
      icon: '/images/LP/LP202407/AmazonECS/Icon/FileCode.svg',
    },
    {
      text: 'アプリケーション運用の簡素化',
      icon: '/images/LP/LP202407/AmazonECS/Icon/Combine.svg',
    },
  ],
}

const MeritContents = [
  {
    title: '効率的なリソース活用でコスト削減',
    text: 'トラフィックの変動に応じてリソースを自動的に調整し、ピーク時のリソース不足やアイドルタイム（待機時間）のコストを削減します。これにより、アプリケーションのパフォーマンスを最適化しつつ、効率的なリソース利用を実現します。',
  },
  {
    title: '障害が発生しても自動で復旧',
    text: 'コンテナやインスタンスに障害が発生した際、自動で再起動し、高可用性を維持します。異常があるコンテナは自動で復旧し、必要な数が確保されるため、ダウンタイムを最小限に抑え、ユーザーエクスペリエンスの向上にも繋がります。',
  },
  {
    title: 'AWSサービスとスムーズな連携',
    text: 'Amazon RDSやAmazon S3などの他のAWSサービスと深く連携し、データストレージやデータベース管理が容易になります。これにより、全体的なシステム管理が簡略化され、開発のスピードアップが図れます。',
  },
  {
    title: '高度なセキュリティ設定が可能',
    text: 'AWSの高度なセキュリティ機能を利用して、データの保護とアクセス制御を厳密に行うことができます。セキュリティグループやIAMロールを使ったアクセス制御により、細かい権限設定が可能です。',
  },
  {
    title: '柔軟なデプロイメントオプションあり',
    text: 'クラスターの起動タイプとして、AWS FargateとAmazon EC2の2種類から選べます。Fargateではサーバーレス環境でのデプロイが可能で、EC2ではEC2インスタンスを利用したクラスター構築ができます。これにより、運用の自由度が高まり、ビジネスニーズに柔軟に対応できます。',
  },
]

const PartnerContents = [
  {
    certification: 'AWS Certified Cloud Practitioner',
    number: '18',
  },
  {
    certification: 'AWS Certified Solutions Architect - Associate',
    number: '9',
  },
  {
    certification: 'AWS Certified SysOps - Associate',
    number: '3',
  },
  {
    certification: 'AWS Certified Developer - Associate',
    number: '4',
  },
  {
    certification: 'AWS Certified Solutions Architect - Professional',
    number: '2',
  },
]

const CaseStudyContents = [
  {
    title: '顧客体験の向上を実現する「HeartOneポータルアプリ」の開発',
    company: '大和ハウスフィナンシャル株式会社',
    image: '/images/LP/LP202407/AmazonECS/img/DaiwaHouseFinancial.png',
    tags: ['アプリケーション開発', 'UX/UIデザイン', 'プロダクトマネジメント', '金融/不動産'],
    href: 'https://aitria.co.jp/cases/heart-one/',
  },
  {
    title: 'AIを使った自動見積りアプリの開発',
    company: 'アート引越センター株式会社',
    image: '/images/LP/LP202407/AmazonECS/img/ArtMovingCompany.png',
    tags: ['アプリケーション開発', 'UX/UIデザイン', '小売/流通/卸'],
    href: 'https://aitria.co.jp/cases/gurutto-ai/',
  },
]

const FlowContents = [
  {
    icon: '/images/LP/LP202407/Icon/BsChatLeftDots.svg',
    title: 'ヒアリング',
    text: '現状の課題とニーズをお伺いし、最適なECS導入プランをご提案いたします。',
  },
  {
    icon: '/images/LP/LP202407/Icon/BsFileEarmarkMedical.svg',
    title: 'ご契約',
    text: 'サービス内容とお見積りにご同意いただいた後、契約を締結します。',
  },
  {
    icon: '/images/LP/LP202407/Icon/BsPersonCheck.svg',
    title: '利用開始',
    text: '環境構築から運用サポートまで、専門チームがトータルにサポートします。',
  },
]

const FAQContents = [
  {
    question: 'Amazon ECSの導入にはどのくらいの期間がかかりますか？',
    answer:
      'プロジェクトの規模や複雑さによって異なりますが、一般的に2〜3ヶ月程度です。ただし、小規模なプロジェクトであれば1ヶ月程度で導入できることもあります。具体的な期間は、初回のコンサルティングでお客さまの要件をお伺いした上で、ご提案いたします。',
  },
  {
    question: '既存のアプリケーションをECSに移行できますか？',
    answer:
      'はい、可能です。お客さまの既存アプリケーションを詳細に分析し、最適な移行戦略を立案いたします。コンテナ化の手法や必要な修正について、段階的なアプローチをご提案し、スムーズな移行をサポートいたします。',
  },
  {
    question: 'ECS導入後のサポート体制はどうなっていますか？',
    answer:
      '定期的な運用レポートの提供、パフォーマンス最適化の提案、セキュリティアップデートの適用など、継続的な改善サポートも行っています。',
  },
  {
    question: '他のコンテナオーケストレーションツールと比べて、Amazon ECSのメリットは何ですか？',
    answer:
      'Amazon ECSは、AWSのマネージドサービスとして提供されるため、インフラ管理の負担が大幅に軽減されます。また、他のAWSサービスとの親和性が高く、シームレスな統合が可能です。さらに、Fargateを使用することで、サーバーレスでのコンテナ運用も実現できます。これらの特徴により、開発チームはインフラ管理よりもアプリケーション開発に集中できます。',
  },
  {
    question: '小規模な開発チームでも、Amazon ECSを効果的に活用できますか？',
    answer:
      'はい、十分に活用できます。ECSはスケーラブルな設計になっているため、小規模なプロジェクトから始めて、徐々に拡張していくことが可能です。また、私たちのサポートチームが、お客さまの開発チームの規模や経験レベルに合わせて、最適な導入・運用方法をご提案します。必要に応じて、技術トレーニングも提供しており、スムーズな導入と効果的な活用をサポートします。',
  },
]

const AmazonECS: React.FC = () => {
  return (
    <>
      <article className={styles.LPPage}>
        <div className={styles.contents}>
          <Top contents={TopContents} paths={paths} />
          <Problem contents={ProblemContents} />
          <Solution contents={SolutionContents} />
          <Merit contents={MeritContents} />
          <Partner contents={PartnerContents} />
          <Suggestion />
          <Architecture />
          <Price />
          <CaseStudy contents={CaseStudyContents} />
          <Flow contents={FlowContents} />
          <FAQ contents={FAQContents} />
          <Introduce />
          <Contact formId={ContactFormId} />
        </div>
      </article>
    </>
  )
}
export default AmazonECS
